import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { initialContractCloseFilterData } from "../../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../../utils/utils";
import ContractCloseFilterData from "../../ContractToClosed/components/ContractCloseFilterData";



const ContractToCloseArchiveFilter = ({ filterData, onSetFilterData, onCallApiAgain, from }) => {
    const dropdownRef = useRef(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
        const id = localStorage.getItem("contractToCloseArchiveSelectedSavefilterId");
        return id ? id : "";
    });

    const count = countNonMatchingEntries(filterData, initialContractCloseFilterData);

    useEffect(() => {
        const handleClose = () => {
            setIsSidebarOpen(false);
        };
        handleDropdownClose(dropdownRef, handleClose);
    }, []);

    const handleFilter = () => {
        localStorage.setItem("contractToCloseArchiveFilterData", JSON.stringify(filterData));
        onCallApiAgain();
        setIsSidebarOpen(false);
        setSelectedSaveFilterId("");
    };

    const handleFilterChange = (value, name) => {
        onSetFilterData({ ...filterData, [name]: value });
    };

    const handleSelectFilter = (value) => {
        const dataToSet = {
            count: value?.count ?? "",
            start_count: value?.start_count ?? "",
            end_count: value?.end_count ?? "",
        };
        localStorage.setItem("contractToCloseArchiveFilterData", JSON.stringify(dataToSet));
        onSetFilterData(dataToSet);
        onCallApiAgain(dataToSet);
    };

    const saveSearchFilterData = {
        count: filterData?.count ?? "",
        start_count: filterData?.start_count ?? "",
        end_count: filterData?.end_count ?? "",

    };

    return (
        <div>
            <SavedFilterComponent
        filterKey="contractToCloseArchiveFilterData"
        selectedFilterIdKey="contractToCloseArchiveSelectedSavefilterId"
                from="Contract to close Archieves Save Filter"
                count={count}
                isSidebarOpen={isSidebarOpen}
                saveSearchFilterData={saveSearchFilterData}
                selectedSavefilterId={selectedSavefilterId}
                initialFilterData={initialContractCloseFilterData}
                onCallApiAgain={onCallApiAgain}
                onSetFilterData={onSetFilterData}
                onSetSelectedSaveFilterId={(value) => {
                    setSelectedSaveFilterId(value);
                }}
                handleSelectFilter={handleSelectFilter}
                onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
            />

            <RightModal
                isOpen={isSidebarOpen}
                onClose={() => {
                    setIsSidebarOpen(false);
                    onSetFilterData(initialContractCloseFilterData);
                }}
                ref={dropdownRef}
                title={"Filter"}
                from={from}
                desc={`Enter Contract To Close information.`}
                onFilter={handleFilter}
                saveSearchFilterData={saveSearchFilterData}
                onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
            >
                <ContractCloseFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} handleFilterChange={handleFilterChange} onSetFilterData={onSetFilterData} from="contractclosearchive" />
            </RightModal>
        </div>
    );
};

export default ContractToCloseArchiveFilter;
